import { Routes } from '@angular/router';
import { UnauthorizedComponent } from '@common/components/unauthorized.component';
import { AppSettings, checkFeatureAvailabilityGuard } from '@common/guards/check-feature-availability.guard';
import { LoginComponent } from './common/components/login/login.component';
import { LogoutComponent } from './common/components/logout.component';
import { ResetPasswordComponent } from './common/components/reset-password/reset-password.component';
import { AuthGuard } from './common/guards/auth.guard';
import { HomeComponent } from './home/home.component';
import { MainLayoutComponent } from './layout/main-layout.component';
import { PreviewLayoutComponent } from './layout/preview-layout.component';
import { TestNumberInputsComponent } from './test-components/test-number-inputs/test-number-inputs.component';
import { UserAccountModule } from './user-account/user-account.module';
import { UserSettingsModule } from './user-settings/user-settings.module';

export const ROUTES: Routes = [
    { path: 'login', component: LoginComponent },
    { path: 'reset-password', component: ResetPasswordComponent },
    { path: '401', component: UnauthorizedComponent },
    { path: 'logout', component: LogoutComponent },
    {
        path: 'invoice/preview/:id',
        component: PreviewLayoutComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: '',
                loadComponent: () =>
                    import('./invoice/components/invoice-preview/invoice-preview.component').then(
                        (c) => c.InvoicePreviewComponent
                    )
            }
        ]
    },
    {
        path: '',
        component: MainLayoutComponent,
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        children: [
            { path: '', redirectTo: '/home', pathMatch: 'full' },
            {
                path: 'administration',
                loadChildren: () =>
                    import('./administration/administration.module').then((m) => m.AdministrationModule),
                data: { title: 'Administration' }
            },
            { path: 'home', component: HomeComponent },
            {
                path: 'user-account',
                loadChildren: () => UserAccountModule,
                data: { title: 'Account' }
            },
            {
                path: 'notice-board',
                loadChildren: () => import('./notice-board/notice-board.module').then((m) => m.NoticeBoardModule),
                canActivate: [checkFeatureAvailabilityGuard],
                data: { title: 'Notifications', check: AppSettings.NoticeBoard }
            },
            {
                path: 'user-settings',
                loadChildren: () => UserSettingsModule,
                data: { title: 'User Settings' }
            },
            {
                path: 'reports',
                loadChildren: () => import('./reports/reports.module').then((m) => m.ReportsModule),
                data: { title: 'Reports' }
            },
            {
                path: 'faq',
                loadChildren: () => import('./faq/faq.module').then((m) => m.FaqModule),
                data: { title: 'FAQ' }
            },
            {
                path: 'vessel-visit',
                loadChildren: () =>
                    import('./vessel-visit/vessel-visit-routing.module').then((m) => m.VesselVisitRoutingModule),
                data: { title: 'Vessel Visit' }
            },
            {
                path: 'vessel',
                loadChildren: () => import('./vessel/vessel.module').then((m) => m.VesselModule),
                data: { title: 'Vessel Visit' }
            },
            {
                path: 'ticket',
                loadChildren: () => import('./ticket/ticket.module').then((m) => m.TicketModule),
                data: { title: 'Tickets' }
            },
            {
                path: 'contract',
                loadChildren: () => import('./contract/contract.module').then((m) => m.ContractModule),
                data: { title: 'Contracts' }
            },
            {
                path: 'customer',
                loadChildren: () => import('./customer/customer.module').then((m) => m.CustomerModule),
                data: { title: 'Customers' }
            },
            {
                path: 'pricelist',
                loadChildren: () => import('./pricelist/pricelist.module').then((m) => m.PricelistModule),
                data: { title: 'Pricelists' }
            },
            {
                path: 'invoice',
                loadChildren: () => import('./invoice/invoice.module').then((m) => m.InvoiceModule),
                data: { title: 'Invoices' }
            },
            {
                path: 'utilities-consumption',
                loadChildren: () =>
                    import('./utilities-consumption/utilities-consumption.module').then(
                        (m) => m.UtilitiesConsumptionModule
                    ),
                data: { title: 'Utilities Consumptions' }
            },
            {
                path: 'utilities-calculation',
                loadChildren: () =>
                    import('./utilities-price-calculation/utilities-price-calculation.module').then(
                        (m) => m.UtilitiesPriceCalculationModule
                    ),
                data: { title: 'Utilities Calculations' }
            },
            {
                path: 'testNumberInputs',
                component: TestNumberInputsComponent,
                data: { title: 'Number Inputs Test' }
            },
            { path: '**', redirectTo: '/home' }
        ]
    }
];
